/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/entity/permalink
 * @desc Column Definition for entity perma_link (Permalink)
 */

import type { ValueGetterParams } from 'ag-grid-community';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import { Link } from 'labstep-web/core/Link';
import type { NewIndexColDef } from 'labstep-web/grid/NewIndex/coldefs/types';
import type { Entity } from 'labstep-web/models/entity.model';
import { navigation } from 'labstep-web/services/navigation';

export const colDefEntityPermalink: NewIndexColDef = {
  colId: 'perma_link',
  headerName: 'Permalink',
  headerComponentParams: {
    icon: 'linkify',
  },
  editable: false,
  valueGetter: (params: ValueGetterParams) => {
    return params?.data?.guid
      ? navigation.get(
          'permalink_show',
          { token: params.data.guid },
          true,
        ) || ''
      : '';
  },
  cellRenderer: (params: CellRendererParams<Entity>) => {
    if (!params.data || !params.data.guid) {
      return '';
    }
    return (
      <Link
        to="permalink_show"
        params={{ token: params.data.guid }}
      ></Link>
    );
  },
};
